import React from "react";
import { Tab, TabProps } from "@mui/material";

export const ChartTab = ({ label, sx, ...other }: TabProps) => (
  <Tab
    label={label}
    sx={{ minWidth: 0, color: "#a3aed080", textTransform: 'capitalize', '&.Mui-selected': { color: '#A3AED0', backgroundColor: '#13162C', borderTopRightRadius: 5, borderTopLeftRadius: 5 }, ...sx }}
    {...other}
  />
);